import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import './Reactions.scss'

const Reactions = ({ url }) => {
  let [reactions, setReactions] = useState(null);
  let [reaction, setReaction] = useState(null);

  useEffect(() => {
    if (url) {
      fetch("/.netlify/functions/reactions", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ slug: url })
      })
        .then(response => response.json())
        .then(setReactions)
    }
  }, []);

  useEffect(() => {
    if (reaction) {
      fetch("/.netlify/functions/sendreaction", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ reactionType: reaction, slug: url })
      })
        .then(response => response.json())
        .then(setReactions)
    }
  }, [reaction]);

  const handleKeyDown = (ev) => {
    // keyboard l for lit
    if (ev.keyCode === 76) {
      setReaction('itslit');
    }
    // keyboard m for meh
    else if (ev.keyCode === 77) {
      setReaction('meh');
    }
  };

  const reactWithItsLit = () => setReaction('itslit');
  const reactWithMeh = () => setReaction('meh');

  return (
    <section className="reactions">
      <div className="reactions__title">This article was...</div>
      <div className="reactions__container">
        <div className="reactions__itslitcontainer" role="button" onClick={reactWithItsLit} onKeyDown={handleKeyDown} tabIndex={0}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="reactions__itslit"
              viewBox="0 0 663.78 845.65"
            >
              <defs>
                <clipPath id="clip-path" transform="translate(45.98 7.98)">
                  <path
                    d="M328.6,788.19c17.44-1.72,120.29-13.6,191.85-105.85,70.18-90.45,57.89-190.65,55.41-208.38,0,0,8.27-48.79-138.1-204.26,0,0-38-24.81,2.48-105.85,0,0-65.33,60.37-54.58,118.26,0,0,81,149.67-27.29,181.92,0,0-146.37,3.31-74.42-149.67,0,0,90.13-87.66,71.11-206.74,0,0,1.66-50.44-87.65-99.23,0,0,49.62,76.9,3.31,123.21C232.26,152,135.8,209.83,78,328.41A434.35,434.35,0,0,0,35,497.94c1.53,26.36,9.91,113.55,79,189.74C197.27,779.41,306.76,787.11,328.6,788.19Z"
                    fill="none"
                  />
                </clipPath>
                <clipPath id="clip-path-2" transform="translate(45.98 7.98)">
                  <path
                    d="M242.72,294.65c11.71-36.19,20.93-48.55,19-49.62-8.57-4.82-220.43,228.61-159.6,389.49,23.59,62.38,90,118.58,163.73,138.92,45.31,12.5,84.91,9.12,109.16,5,25-8.9,78.89-32.31,115.67-87.8,50.42-76.08,47.93-181.17-4.86-270.26,21.87,86.6-19.46,154.44-61.77,161.33-29.62,4.83-63.7-19.55-87.08-53.83-49.09,32.63-73,27.95-84.35,22.33C202.16,525.11,212.85,387,242.72,294.65Z"
                    fill="none"
                  />
                </clipPath>
                <clipPath id="clip-path-3" transform="translate(45.98 7.98)">
                  <path
                    d="M164.12,424.72S49.63,701.5,233.4,768.83c0,0,87.61,35,158.6,0a185,185,0,0,0,53.27-41c51.85-58,49.25-131.28,48-150.5-19.88,47.36-56,123.33-85.1,118.53a17.17,17.17,0,0,1-1.83-.41c-4.88-.27-48.28-3.36-69.15-38.35A74.36,74.36,0,0,1,327,622.8c.74,6.35,3.43,34.87-14.21,51.79-22.07,21.17-70.25,18.7-106.52-17.88a296.36,296.36,0,0,1-18.38-33.23C152,547.45,156.27,472,164.12,424.72Z"
                    fill="none"
                  />
                </clipPath>
              </defs>
              <g style={{ isolation: 'isolate' }}>
                <g id="fire_mid">
                  <path
                    id="fire_mid_path"
                    d="M260.44,522.76C377.69,457.57,402.08,406.36,401,370.61,399.41,321.82,349,260.14,355.67,199a280.94,280.94,0,0,1,8-40.67C368.26,142.22,374.3,121,387,103c30-42.59,90.08-57,89.5-58.18,0-.07-.25,0-.28,0-23.64,2.06-77.41,9.94-130.68,48.46a258.17,258.17,0,0,0-80.92,96.54,87.49,87.49,0,0,0,20.3-12.9c1.16-1,18.64-17.09,21.52-35.34C310.37,116.65,286,94.33,273.67,83c-55.58-51-144.61-55.69-180-56C196.5,42.47,221.34,69.25,226.33,89.67c10.8,44.1-68.08,70.64-96.66,166.66-5.52,18.55-26.36,97.42,16.66,172.67C181.62,490.72,240,515.25,260.44,522.76Z"
                    transform="translate(45.98 7.98)"
                    fill="#3d73b9"
                  />
                  <path
                    d="M569,175.67"
                    transform="translate(45.98 7.98)"
                    fill="#3d73b9"
                  />
                </g>
                <g id="fire_top">
                  <path
                    d="M328.6,788.19c17.44-1.72,120.29-13.6,191.85-105.85,70.18-90.45,57.89-190.65,55.41-208.38q-7-21.85-14.16-43.83-28.8-87.87-59.37-171.8c-1.74-4.07-25.81-63.08,9.34-113.33,21.27-30.41,52.24-40.45,62.66-43.33-81.27-1.69-148.16,41-165.41,99.6-10.65,36.17.22,69.49,7.41,86.4,21.69,57.4,16,116.07-17.68,150.9-7.67,7.94-20.34,18.31-40.28,25.46-50.06-5.24-72.86-23.83-84.1-37.52-54-65.71-7.2-220.18,130.73-378.18a211.39,211.39,0,0,0-43.33,15.34c-89.54,43.25-122.34,138.49-132,171.33-2.59-30.08-12.93-99.41-66-160.67A267.17,267.17,0,0,0,100.33,21Q217,305.59,195.67,316.33q-18.84,9.5-145.34-194.66c17.09,70.64,30.75,172.51,8,289.33A648.6,648.6,0,0,1,35,497.94c1.53,26.36,9.91,113.55,79,189.74C197.27,779.41,306.76,787.11,328.6,788.19Z"
                    transform="translate(45.98 7.98)"
                    fill="#be6dac"
                  />
                </g>
                <g id="Layer_5" data-name="Layer 5">
                  <g clipPath="url(#clip-path)">
                    <polyline
                      points="290.84 368.36 229.98 137.51 142.72 287.25"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="52.31 604.16 217.64 776.39 221.18 603.11"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="376.22 132.6 506.47 332.67 542.31 163.1"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="246.11 327.13 473.18 253.41 318.77 174.69"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="346.09 323.63 285.24 92.77 197.97 242.52"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="428.62 143.62 200.08 212.66 352.84 294.54"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="416.76 821.49 608.46 679.19 437.01 653.83"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="372.13 369.01 599.21 295.29 444.8 216.57"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="440.33 235.67 379.47 4.81 292.21 154.56"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="315.94 202.82 87.4 271.86 240.16 353.73"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="398.99 285.46 529.24 485.54 565.09 315.97"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="245.54 152.89 472.61 79.17 318.2 0.45"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="53.07 432.82 115.19 663.34 201.63 513.12"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="663.35 522.8 540.85 317.89 498.54 485.96"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="575.02 717.82 656.49 493.41 499.47 566.79"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="296.15 425.65 426.4 625.73 462.24 456.16"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="244.11 453.89 183.26 223.03 95.99 372.78"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="229.84 338.66 1.3 407.7 154.06 489.58"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="334.36 482.62 330 243.92 209.7 368.69"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="358.08 353.85 488.33 553.92 524.17 384.35"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="369.7 532.7 228.06 340.52 202.12 511.89"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="560.26 474.43 331.72 543.47 484.48 625.34"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="192.15 622.32 419.23 548.6 264.82 469.88"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="455.67 442.57 585.93 642.64 621.77 473.07"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="548 561.92 543.64 323.22 423.34 447.99"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="385.2 348.06 324.35 117.21 237.08 266.95"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                  </g>
                </g>
                <g id="fire_bot">
                  <path
                    id="fire_bot_path"
                    d="M223,335c-21.33-70-169.33-68.67-201.33-75.33s63.8,24.11,120.66,90.66c107.86,126.25,37.39,291.21,125.75,344.13,34.07,20.41,78.92,18.66,109.16,5C431.83,674.7,433.46,613,484.33,529.67c22.55-36.92,59.23-85.36,120.67-133.34a459.62,459.62,0,0,0-123.77,55.59C427.59,486.42,406.32,516.3,391,509c-33.14-15.79-.8-170.76,4.67-179.67s-42.5,37.13-52.74,92.6c-15.36,83.23,29.89,143,15.15,152.16-14.17,8.84-40.31-64.88-103.23-102.9C223.49,452.24,244.33,405,223,335Z"
                    transform="translate(45.98 7.98)"
                    fill="#7153a2"
                    style={{ mixBlendMode: 'color-burn' }}
                  />
                </g>
                <g id="Layer_4" data-name="Layer 4">
                  <g clipPath="url(#clip-path-2)">
                    <polyline
                      points="399.35 702.96 512.4 754.02 480.58 669.78"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="221.96 583.06 335 634.13 303.19 549.88"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="360.7 498.69 318.23 615.23 401.06 577.64"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="321.96 790.16 445.99 788.54 381.48 724.42"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="320.86 695.87 293.24 574.94 245.34 651.19"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="512.61 730.61 388.66 735.28 454.69 796.51"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="481.16 694.42 571.58 609.51 481.58 606.68"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="480.71 705.93 453.1 585 405.2 661.25"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="515.2 737.66 505.75 613.98 447.11 682.32"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="344.55 763.56 434.97 678.65 344.97 675.82"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="382.14 660.72 258.19 665.4 324.22 726.63"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="237.89 654.62 210.27 533.69 162.37 609.94"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="479.34 722.28 569.77 637.38 479.76 634.54"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="369.29 612.51 245.34 617.18 311.37 678.41"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="482.04 664.42 358.18 657.74 418.32 724.75"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="365.38 704.59 455.81 619.69 365.8 616.85"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="230.8 577.13 188.33 693.68 271.16 656.09"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="320.17 576.83 196.22 581.5 262.25 642.73"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="564.13 629.97 536.51 509.04 488.61 585.29"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="368.12 749.44 489.31 723.01 413.54 674.37"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="250.86 780.34 374.36 791.98 316.94 722.61"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="186.04 738.29 276.46 653.38 186.46 650.55"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="441.12 552.79 317.26 546.1 377.41 613.11"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="468.5 688.13 440.89 567.2 392.99 643.45"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="291.64 658.74 249.17 775.28 332 737.7"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="473.74 567.34 349.88 560.65 410.03 627.66"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="455.67 673.84 546.1 588.93 456.09 586.1"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="360.47 536.55 236.52 541.22 302.54 602.45"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="178.09 704.57 262.27 795.68 265.83 705.7"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="192.65 686.92 305.69 737.99 273.87 653.75"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="241.51 564.67 213.9 443.74 166 519.99"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="299.18 620.3 420.11 647.9 372.2 571.66"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="347.89 235.67 223.94 240.34 289.96 301.57"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="201.67 301.8 314.71 352.86 282.9 268.62"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="223.93 407.14 314.35 322.23 224.35 319.4"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="259.25 317.89 216.78 434.43 299.61 396.85"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="153.33 392.17 276.46 407.14 221.09 334.98"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="302.37 392.04 178.41 396.71 244.44 457.94"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="237.89 494.66 210.27 373.73 162.37 449.98"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="212.98 536.03 303.4 451.12 213.4 448.29"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="194.77 424.99 107.85 513.48 198.8 513.57"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="191.08 611.39 163.47 490.46 115.57 566.71"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="276 618.97 389.04 670.03 357.22 585.79"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="127.35 620.58 240.39 671.64 208.57 587.4"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="307.89 580.85 220.97 669.34 311.93 669.43"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="241.51 685.68 364.64 700.65 309.27 628.49"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="530.02 518.22 597.47 414.12 509.4 432.94"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="546.06 677.19 613.5 573.09 525.44 591.91"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="489.8 471.94 564.25 571.15 577.98 481.24"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="519.7 760.4 552.96 640.9 473.31 684.83"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="287.65 581.52 256.03 461.57 210.69 539.38"
                      fill="#ec008c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="268.18 550.58 153.2 504.05 187.86 588.14"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="127.35 605.62 184.26 715.83 212.75 629.46"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="373.16 598.35 286.25 686.85 377.2 686.93"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="224.35 569.5 100.39 574.17 166.42 635.4"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="398.58 586.74 283.59 540.21 318.26 624.31"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="535.73 628.87 626.16 543.96 536.15 541.13"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="254.06 502.76 167.15 591.25 258.1 591.34"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                  </g>
                </g>
                <g
                  id="Layer_2"
                  data-name="Layer 2"
                  style={{ mixBlendMode: 'luminosity' }}
                >
                  <g clipPath="url(#clip-path-3)">
                    <polyline
                      points="288.75 697.96 393.43 764.5 373.85 676.61"
                      fill="#a70434"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="214.3 705.96 301.61 794.07 302.02 704.02"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="355.73 608.26 355.73 732.3 419.4 668.63"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="349.18 810.47 332.06 687.62 277.79 759.47"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="162.25 663.09 247.67 573.14 157.65 575.47"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="161.58 548.08 238.95 645.03 249 555.54"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="595.38 592.87 473.11 572 525.16 645.48"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="258.16 519.87 152.41 455.04 173.42 542.61"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="443.55 646.65 553.53 704.02 526.52 618.12"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="234.62 401.76 136.74 477.96 226.1 489.09"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="189.88 763.91 271.24 670.28 181.41 676.58"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="546.02 739.24 487.01 630.13 461.29 716.43"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="247.67 521.22 123.7 525.5 189.53 586.94"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="489.2 732.06 383.85 666.59 404.32 754.28"
                      fill="#a70434"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="303.7 778.45 212.62 694.25 216.15 784.23"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="519.31 680.27 399.22 711.33 476.81 757.03"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="328 724.1 358.42 844.35 404.53 767.01"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="235.17 599.43 132.57 669.15 221.03 686.03"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="324.88 729.33 234.62 644.24 237.28 734.25"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="410.28 807.26 512.3 736.71 423.71 720.55"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="393.92 829.59 471.8 733.05 382.26 742.63"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="401.1 799.06 423.93 677.14 349.62 728.01"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                  </g>
                </g>
              </g>
            </svg>
            <div>{reactions && reactions.reactions && reactions.reactions.itslit ? reactions.reactions.itslit : 0}</div>
          </div>
        <div className="reactions__mehcontainer" role="button" onClick={reactWithMeh} onKeyDown={handleKeyDown} tabIndex={0}>
            <svg
              className="reactions__meh"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 753.16 711.66"
            >
              <defs>
                <clipPath id="clip-path-meh" transform="translate(87.98 44.17)">
                  <ellipse
                    cx="307.19"
                    cy="306.14"
                    rx="288.35"
                    ry="296.8"
                    fill="none"
                  />
                </clipPath>
              </defs>
              <g style={{ isolation: 'isolate' }}>
                <g id="Layer_6" data-name="Layer 6">
                  <g clipPath="url(#clip-path-meh)">
                    <polyline
                      points="438.42 345.79 568.03 430.6 543.79 318.59"
                      fill="#a70434"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="229.04 543.85 337.14 656.14 337.64 541.38"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="600.33 283.45 600.33 441.53 679.16 360.38"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="410.14 267.47 388.94 110.91 321.74 202.48"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="164.59 489.22 270.34 374.59 158.89 377.56"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="388.46 100.53 484.26 224.09 496.7 110.04"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="354.63 331.52 471.7 438.74 484.98 298.83"
                      fill="#703393"
                      stroke="#001431"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="274.11 335.1 446.36 419.82 400.19 285.32"
                      fill="#442b7b"
                      stroke="#4691ce"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="469.52 324.81 250.95 392.78 397.05 473.37"
                      fill="#8e70b2"
                      stroke="#6d54a3"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="351.75 431.24 531.34 497.88 472.39 368.78"
                      fill="#442b7b"
                      stroke="#4691ce"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="607.63 451.12 514.66 321.28 473.53 455.34"
                      fill="#703393"
                      stroke="#001431"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="503.23 330.08 351.83 303.48 416.28 397.12"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="640.96 306.7 510.02 224.09 536.03 335.68"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="512.88 468.27 649.05 541.38 615.61 431.91"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="254.19 156.19 133 253.29 243.64 267.47"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="429.67 343.11 530.4 223.79 419.18 231.82"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="527.25 434.79 454.18 295.75 422.34 405.73"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="270.34 308.43 116.86 313.88 198.36 392.18"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="605.25 262.47 453.58 1.32 401.2 215.52"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="651.41 577.78 752.28 291.79 557.87 385.3"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="443.42 439.49 604.7 694.46 649.08 478.36"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="268.73 426.1 193.38 131.9 85.34 322.73"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="284.23 284.79 1.27 372.78 190.41 477.12"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="380.47 462.71 375.07 158.51 226.13 317.52"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="252.44 58.45 162.14 186.32 272.26 168.39"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="392.92 587.9 285.3 700.67 397.92 700.78"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="365.4 563.02 517.86 582.09 449.3 490.13"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="622.73 508.09 706.23 375.42 597.2 399.4"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="528.89 524.85 612.39 392.18 503.36 416.16"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="498.76 343.07 590.95 469.5 607.95 354.91"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="503.3 371.89 544.48 219.6 445.87 275.58"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="435.98 67.45 597.26 322.43 641.63 106.33"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="487.62 611.68 312.24 366.76 280.12 585.15"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="736.84 127.63 453.88 215.62 643.02 319.96"
                      fill="#53c9eb"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="323.99 450.61 605.14 356.65 413.96 256.33"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="495.18 247.03 656.45 502.01 700.83 285.91"
                      fill="#8fd4db"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="313.23 697.49 307.83 393.29 158.89 552.3"
                      fill="#005999"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="433.31 300.15 357.96 5.95 249.91 196.78"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="298.53 549.32 156.17 490.03 199.08 597.19"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="260.35 560.32 330.81 700.78 366.1 590.71"
                      fill="#ca4c9c"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="487.29 587.9 379.67 700.67 492.29 700.78"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="171.51 230.32 395.17 155.58 243.08 75.78"
                      fill="#643996"
                      stroke="#001431"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="218.89 23.9 323.05 188.57 351.71 49.01"
                      fill="#442b7b"
                      stroke="#4691ce"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="524.57 636 431.6 506.16 390.47 640.21"
                      fill="#703393"
                      stroke="#001431"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="371.14 470.93 224.29 290.99 209.93 460.95"
                      fill="#8e70b2"
                      stroke="#6d54a3"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="299.6 517.57 528.62 572.48 438.44 423.29"
                      fill="#643996"
                      stroke="#001431"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="302.68 226.35 406.84 391.02 435.5 251.46"
                      fill="#442b7b"
                      stroke="#4691ce"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="191.16 360.51 369.09 213.24 204.3 194.82"
                      fill="#8e70b2"
                      stroke="#6d54a3"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="116.86 424.32 171.76 571.95 217.2 467.16"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="459.98 595.41 317.62 536.11 360.53 643.28"
                      fill="#f173ac"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="369.81 156.44 481.77 48.23 370.33 44.62"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="281.05 488.38 173.44 601.15 286.05 601.26"
                      fill="#eb2790"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="595.63 599.51 465.18 516.07 490.53 627.83"
                      fill="#a70434"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="483.91 443.25 371.14 335.94 375.51 450.61"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="553.36 51.62 404.67 91.19 500.73 149.44"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="362.77 557.09 400.42 710.34 457.52 611.77"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="254.87 408.1 127.84 496.95 237.36 518.46"
                      fill="#d91348"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="395.09 387.01 283.34 278.58 286.63 393.29"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="471.69 698.53 598 608.61 488.32 588.03"
                      fill="#c60e41"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="392.16 577.59 488.59 454.56 377.73 466.76"
                      fill="#ed174f"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="330.08 579.7 358.34 424.32 266.34 489.15"
                      fill="#8d0028"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                      style={{ mixBlendMode: 'multiply' }}
                    />
                    <polyline
                      points="340.85 115.62 445.41 231.41 449.48 116.73"
                      fill="#c40075"
                      stroke="#ec008c"
                      strokeMiterlimit="10"
                    />
                    <polyline
                      points="585.52 360.51 410.14 115.6 378.02 333.98"
                      fill="#388dcc"
                      stroke="#c3d2ec"
                      strokeMiterlimit="10"
                    />
                  </g>
                </g>
                <g id="mouth">
                  <path
                    d="M444.2,498.46,143.88,438.35c-8.33-1.66-13.14-12.62-10.7-24.34l3.42-16.38c2.44-11.73,11.25-20,19.58-18.3l281.21,84.95c4.42.88,18.2,6,25.18,12.69a19,19,0,0,1,5.84,13.39C466,502.09,452.52,500.13,444.2,498.46Z"
                    transform="translate(87.98 44.17)"
                    fill="#000"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="6"
                  />
                </g>
                <g id="righteye">
                  <ellipse
                    cx="492.29"
                    cy="293.18"
                    rx="75.17"
                    ry="73.58"
                    fill="#000"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="6"
                  />
                </g>
                <g id="lefteye">
                  <ellipse
                    cx="299.6"
                    cy="291.79"
                    rx="57.04"
                    ry="72.19"
                    fill="#000"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth="6"
                  />
                </g>
              </g>
            </svg>
            <div>{reactions && reactions.reactions && reactions.reactions.meh ? reactions.reactions.meh : 0}</div>
          </div>
      </div>
    </section>
  )
}

Reactions.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
}

export default Reactions
